import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import { BrandSignate, CloseIcon } from '$partials/icon';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const HeaderNavigation = forwardRef((props, ref) => {
    const {
        closeClick      = () => {},
        open            = false,
        contactDetails  = [],
        navigationLinks = []
    } = props;

    const chunkArray = (arr, chunkCount) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += chunkCount)
        {chunks.push(arr.slice(i, i + chunkCount));}
        return chunks;
    };

    const navLinksCols = chunkArray(navigationLinks, 4);

    return (
        <dialog
            className={`fixed left-0 top-0 height-100 width-100 border-0 m0 p0 overflow-auto z3 transition-navigation-dialog${open ? ' transition-navigation-dialog--active' : ''}`}
            inert={open ? null : ''}
            open={true}
            ref={ref}>
            {/* inner */}
            <div className={`overflow-hidden width-100 transition-navigation-inner${open ? ' transition-navigation-inner--active' : ''}`}>
                {/* content */}
                <div className='container flex flex-wrap'>

                    {/* header */}
                    <div className='col-12 flex flex-wrap mt6 md-mt8'>
                        <div className='col-12 flex'>
                            <button
                                aria-label='Close Navigation'
                                className='form-field-reset link-reset cursor-pointer'
                                onClick={closeClick}
                                type='button'>
                                <CloseIcon className='mr5'/>
                            </button>

                            <p className='type-style-5'>Menu</p>
                        </div>

                        {props.signate?.url ? (
                            <img
                                className='signate mt3 sm-mt5'
                                src={props.signate.url} />
                        ) : (
                            <BrandSignate className='mt3 sm-mt5' />
                        )}
                    </div>

                    {/* Link Section */}
                    <div className='col-12 flex flex-wrap md-mtn-5 sm-mt9 mt6'>
                        <div className='md-show col-2'/>
                        {navLinksCols?.map((items, idx) => {
                            return (
                                <div
                                    className='col-12 sm-col-4 md-col-3 flex flex-col pb2 sm-pb0'
                                    key={`nav-links-col-${idx}`}>
                                    {items.map((item, id) =>{
                                        const linkTo = item.link?.linkTo;
                                        let link = '';
                                        switch (linkTo) {
                                            case 'email':
                                                link = 'mailto:' + item.link[linkTo];
                                                break;
                                            case 'anchor':
                                                link = item.link[linkTo];
                                                break;
                                            case 'custom_url':
                                                link = item.link?.customUrl;
                                                break;
                                            case 'file':
                                                break;
                                            case 'page':
                                                link = item.link[linkTo]?.url;
                                                break;
                                            case 'phone':
                                                link = 'tel:' + item.link[linkTo];
                                                break;
                                        }
                                        return (
                                            <a
                                                className={`link-reset type-style-2 sm-pr6${id !== items.length -1 ? ' pb2 sm-pb5 md-pb6' : ''}`}
                                                href={link}
                                                key={item?.id}
                                                rel='noreferrer'
                                                target={item.link?.new_window || item.link?.linkTo === 'file' ? '_blank' : ''}>{item.label}</a>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>

                    {/* Divider */}
                    <hr className='col-12 md-push-left-2 md-push-right-1 black mt6 sm-mt9 mb6 sm-mb9'/>

                    {/* Contact section */}
                    <div className='col-12 flex flex-wrap'>
                        <div className='md-show col-2'/>
                        {contactDetails.map((contact, idx) => {
                            return (
                                <div
                                    className={`col-12 sm-col-4 md-col-3 flex flex-col${idx ? ' hide sm-show' : ''}`}
                                    key={contact?.id}>
                                    <h3 className='type-style-5 sm-type-style-3 mb5'>{contact.title}</h3>
                                    <div
                                        className='rich-text header-navigation type-style-6 mb5'
                                        dangerouslySetInnerHTML={{__html: contact.body}}/>
                                </div>);
                        })}
                    </div>
                </div>
            </div>
        </dialog>
    );
});

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

HeaderNavigation.displayName = 'HeaderNavigation';

const propTypes = {
    closeClick     : PropTypes.func,
    open           : PropTypes.bool,
    contactDetails : PropTypes.array,
    navigationLinks: PropTypes.array,
    signate        : PropTypes.object
};

HeaderNavigation.propTypes = propTypes;

export { HeaderNavigation };

export default HeaderNavigation;
